export default "__VITE_ASSET__Cnqm8c5u__"